import Crud from '../views/VehicleLicensingMonth/Crud'
import Entity from '../views/VehicleLicensingMonth/Add'

let routes = {
    path: '/vehicle_licensing_months',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicle_licensing_months/add',
            name: 'NewVehicleLicensingMonth',
            component: Entity,
            meta: {
                pageTitle: 'Vehicle Licensing Month',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_licensing_months'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_licensing_months/edit/:id?',
            name: 'EditVehicleLicensingMonth',
            component: Entity,
            meta: {
                pageTitle: 'Vehicle Licensing Month',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_licensing_months'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_licensing_months',
            name: 'list-vehicle-licensing-months',
            component: Crud,
            meta: {
                pageTitle: 'Vehicle Licensing Month',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
